<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <EditTask />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import EditTask from "./components/EditTask";

// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    EditTask,
    // ProjectsTable,
  },
};
</script>
